import {
  Box,
  Radio,
  Skeleton,
  RadioGroup,
  Typography,
  FormControlLabel,
} from "@mui/material";
import React from "react";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const MergeLeadsSkeleton: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: nawyTheme.nawy.spacing.xl,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          marginTop: nawyTheme.nawy.spacing.lg,
        }}
      >
        <Typography
          sx={{
            ...nawyTheme.nawy.typography.english.variants.body.xs.semibold,
            color: nawyTheme.nawy.colors.semantic.text.secondary,
          }}
        >
          Name
        </Typography>

        <RadioGroup row sx={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: "16px",
              width: "100%",
            }}
          >
            {[1, 2].map((i) => (
              <Box key={i} sx={{ flex: 1, minWidth: 0 }}>
                <FormControlLabel
                  value={`skeleton-${i}`}
                  control={<Radio disabled />}
                  label={
                    <Skeleton
                      variant="text"
                      height={28}
                      sx={{
                        ...nawyTheme.nawy.typography.english.variants.body.md
                          .regular,
                      }}
                    />
                  }
                  sx={{
                    width: "100%",
                    "& .MuiFormControlLabel-label": {
                      color: nawyTheme.nawy.colors.semantic.text.primary,
                      display: "flex",
                    },
                  }}
                />
              </Box>
            ))}
          </Box>
        </RadioGroup>
      </Box>

      {[1, 2].map((groupIdx) => (
        <Box
          key={groupIdx}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: nawyTheme.nawy.spacing.md,
          }}
        >
          {[1, 2, 3].map((field) => (
            <Box key={field}>
              <Skeleton variant="text" width="30%" height={20} />
              <Skeleton variant="rectangular" width="100%" height={48} />
            </Box>
          ))}
        </Box>
      ))}

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Skeleton variant="text" width="40%" height={24} />
        {[1, 2].map((i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width="100%"
            height={64}
            sx={{ borderRadius: nawyTheme.nawy.radius.lg }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default MergeLeadsSkeleton;
